//@flow
export const CONNECT_CHARITY_RESOURCE = 'stripe/connect/charity'

export const CONNECT_CHARITY_REQUEST = 'STRIPE_CONNECT_REQUEST'
export const CONNECT_CHARITY_SUCCESS = 'STRIPE_CONNECT_SUCCESS'
export const CONNECT_CHARITY_FAILED = 'STRIPE_CONNECT_FAILED'



// WEBPACK FOOTER //
// ./src/services/stripe/constants.js